module.exports = __webpack_public_path__ + "img/mail.cffbc7ee.svg";